import { GameContext } from '../../../contexts/GameContext';
import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import { MGameStepConfiguration } from '../../../configuration/games/m-game/mGameContentConfiguration';
import { mCustomCiphers } from '../../../configuration/games/m-game/mGameCustomCiphers';
import MBuckyCipher from './ciphers/MBuckyCipher';
import MGeryonCipher from './ciphers/MGeryonCipher';
import MHadesCipher from './ciphers/MHadesCipher';
import MJanusCipher from './ciphers/MJanusCipher';
import MKalypsoCipher from './ciphers/MKalypsoCipher';
import MLittlePrinceCipher from './ciphers/MLittlePrinceCipher';
import MMap from './MMap';
import MMedusaCipher from './ciphers/MMedusaCipher';
import MRomComsCipher from './ciphers/MRomComsCipher';
import MTinderCipher from './ciphers/MTinderCipher';
import React, { useContext } from 'react';
import parse from 'html-react-parser';

type Props = {
    onClickNext: () => void;
};

export default function MCipher({ onClickNext }: Props) {
    const { stepContent } = useContext(GameContext);
    const { isMap, mapPlace, cipher, mapImage } = stepContent as MGameStepConfiguration;

    const renderImage = (i: number, image: any) => {
        return (
            <div key={i} className="m-cipher-image">
                <ImageWrapper src={image} alt="cipher" shouldScroll={true} allowLightbox={false} />
            </div>
        );
    };

    if (isMap) {
        return <MMap markerPosition={mapPlace} onClick={onClickNext} image={mapImage} />;
    }

    if (cipher && cipher.images) {
        return (
            <div className="m-cipher-wrapper">
                {cipher.images?.map((image, i) => {
                    return renderImage(i, image);
                })}
                {cipher.text && (
                    <div className="m-cipher-text-wrapper">
                        <div className="m-cipher-text">{parse(cipher.text)}</div>
                    </div>
                )}
            </div>
        );
    }

    if (cipher && cipher.text) {
        return (
            <div className="m-cipher-text-wrapper">
                <div className="m-cipher-text">{parse(cipher.text)}</div>
            </div>
        );
    }

    if (cipher && cipher.custom) {
        if (mCustomCiphers.romComs === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MRomComsCipher />
                </div>
            );
        }
        if (mCustomCiphers.bucky === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MBuckyCipher />
                </div>
            );
        }
        if (mCustomCiphers.janus === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MJanusCipher />
                </div>
            );
        }
        if (mCustomCiphers.medusa === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MMedusaCipher />
                </div>
            );
        }
        if (mCustomCiphers.geryon === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MGeryonCipher />
                </div>
            );
        }
        if (mCustomCiphers.kalypso === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MKalypsoCipher />
                </div>
            );
        }
        if (mCustomCiphers.hades === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MHadesCipher />
                </div>
            );
        }
        if (mCustomCiphers.prince === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MLittlePrinceCipher />
                </div>
            );
        }
        if (mCustomCiphers.tinder === cipher.custom) {
            return (
                <div className="m-cipher-text-wrapper">
                    <MTinderCipher onNext={onClickNext} />
                </div>
            );
        }
    }

    return <React.Fragment />;
}
